import { applyInsiderSorting } from "@domains/features/Markets/Equity/utils/equitySort";
import { INSIDER_STOP_LOADER, INSIDER_TRADING_ERROR, INSIDER_TRADING_HIDE_ERROR, INSIDER_START_LOADER, INSIDER_SORT, INSIDER_CLEAR_SORT, } from "../../interface/iInsiderTradingSast";
import { INSIDER_TRADING } from "../../interface/iInsiderTradingSast";
const initialState = {
    data: [],
    sortData: {
        sortState: [],
        data: [],
    },
    insiderTradingLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const insiderTrading = (state = initialState, action) => {
    var _a, _b;
    switch (action.type) {
        case INSIDER_TRADING:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case INSIDER_TRADING_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case INSIDER_TRADING_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case INSIDER_START_LOADER:
            return Object.assign(Object.assign({}, state), { insiderTradingLoader: true });
        case INSIDER_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { insiderTradingLoader: false });
        case INSIDER_SORT:
            return Object.assign(Object.assign({}, state), { sortData: applyInsiderSorting((_a = action.payload) === null || _a === void 0 ? void 0 : _a.sortData, (_b = action.payload) === null || _b === void 0 ? void 0 : _b.sortingType, state.data) });
        case INSIDER_CLEAR_SORT:
            return Object.assign(Object.assign({}, state), { sortData: initialState.sortData });
        default:
            return Object.assign({}, state);
    }
};
export default insiderTrading;
